/**
 * The API base URL for fetching survey configuration data.
 */
export const SURVEY_BASE_URL = 'https://custom-p0.feedbook.me/api/feedback/survey/cfm';
